import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SustainabilityHeader = ({ 
  selectedPeriod, 
  onPeriodChange, 
  selectedFacility, 
  onFacilityChange,
  selectedFramework,
  onFrameworkChange,
  onExportReport 
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const reportingPeriods = [
    { value: 'q1-2024', label: 'Q1 2024 (Jan-Mar)' },
    { value: 'q2-2024', label: 'Q2 2024 (Apr-Jun)' },
    { value: 'q3-2024', label: 'Q3 2024 (Jul-Sep)' },
    { value: 'q4-2024', label: 'Q4 2024 (Oct-Dec)' },
    { value: 'fy-2024', label: 'FY 2024 (Full Year)' },
    { value: 'ytd-2024', label: 'YTD 2024' }
  ];

  const facilities = [
    { value: 'all', label: 'All Facilities' },
    { value: 'main-plant', label: 'Main Plant - Detroit' },
    { value: 'west-facility', label: 'West Facility - Phoenix' },
    { value: 'east-facility', label: 'East Facility - Atlanta' },
    { value: 'north-facility', label: 'North Facility - Chicago' }
  ];

  const esgFrameworks = [
    { value: 'gri', label: 'GRI Standards' },
    { value: 'sasb', label: 'SASB Framework' },
    { value: 'tcfd', label: 'TCFD Guidelines' },
    { value: 'custom', label: 'Custom Framework' }
  ];

  const handleExport = async () => {
    setIsExporting(true);
    await onExportReport();
    setTimeout(() => setIsExporting(false), 2000);
  };

  return (
    <div className="bg-card border-b border-border p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Title Section */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-success/10 rounded-lg">
            <Icon name="Leaf" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Sustainability Analytics Hub</h1>
            <p className="text-sm text-muted-foreground">Environmental compliance & ESG reporting dashboard</p>
          </div>
        </div>

        {/* Controls Section */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Select
            label=""
            placeholder="Select Period"
            options={reportingPeriods}
            value={selectedPeriod}
            onChange={onPeriodChange}
            className="w-full sm:w-48"
          />
          
          <Select
            label=""
            placeholder="Select Facility"
            options={facilities}
            value={selectedFacility}
            onChange={onFacilityChange}
            className="w-full sm:w-52"
          />
          
          <Select
            label=""
            placeholder="ESG Framework"
            options={esgFrameworks}
            value={selectedFramework}
            onChange={onFrameworkChange}
            className="w-full sm:w-44"
          />

          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            loading={isExporting}
            onClick={handleExport}
            className="whitespace-nowrap"
          >
            Export Report
          </Button>
        </div>
      </div>

      {/* Quick Stats Bar */}
      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <div>
            <p className="text-xs text-muted-foreground">Data Coverage</p>
            <p className="text-sm font-semibold text-foreground">98.5%</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
          <div className="w-2 h-2 bg-primary rounded-full"></div>
          <div>
            <p className="text-xs text-muted-foreground">Last Updated</p>
            <p className="text-sm font-semibold text-foreground">2 hours ago</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
          <div className="w-2 h-2 bg-warning rounded-full"></div>
          <div>
            <p className="text-xs text-muted-foreground">Compliance Score</p>
            <p className="text-sm font-semibold text-foreground">94.2%</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
          <div className="w-2 h-2 bg-accent rounded-full"></div>
          <div>
            <p className="text-xs text-muted-foreground">Active Goals</p>
            <p className="text-sm font-semibold text-foreground">12 of 15</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityHeader;